import { errorValidation } from './utils';

let cabinetPhone = $('#cabinet_phone');

/**
 * Init intlTelInput
 */
[cabinetPhone].forEach(phoneInput => {
	phoneInput
		.intlTelInput({
			initialCountry: 'md',
			placeholderNumberType: 'aggressive',
			utilsScript:
				'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.14/js/utils.js',
			separateDialCode: true,
			preferredCountries: ['md'],
			onlyCountries: ['ro', 'ua', 'md'],
		})
		.inputmask({
			mask: 'V9999999',
			definitions: {
				V: {
					validator: '^[1-9][0-9]*$',
				},
			},
		});

	// Set the initial country code on page load
	let initialCountryCode = phoneInput.intlTelInput(
		'getSelectedCountryData'
	).dialCode;
	let countryCodeInput = phoneInput
		.closest('.input-wrapper')
		.find('.country-code');
	countryCodeInput.val(initialCountryCode);

	// On blur: validate
	phoneInput.focusout(function () {
		if ($.trim(phoneInput.val())) {
			if (phoneInput.intlTelInput('isValidNumber')) {
				console.log('isValidNumber');
				// Save country code
				countryCodeInput.val(initialCountryCode);
			} else {
				phoneInput.addClass('_error');
			}
		}
	});

	// On keydown: reset
	phoneInput.keydown(function () {
		phoneInput.removeClass('_error');
	});
});

/**
 * Add custom validation method
 */
$.validator.addMethod(
	'validateCabinetPhone',
	function (value, element) {
		return $(element).intlTelInput('isValidNumber');
	},
	window.translations.phoneInvalid
);

/**
 * Validate forms
 */
(() => {
	// Cabinet
	$("form[name='cabinet']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'cabinet[name]': {
				required: true,
			},
			'cabinet[surname]': {
				required: true,
			},
			'cabinet[email]': {
				required: true,
				email: true,
			},
			'cabinet[phone]': {
				required: true,
				validateCabinetPhone: true,
			},
			'register[company]': {
				required: true,
			},
			'register[legal_address]': {
				required: true,
			},
		},
		messages: {
			'cabinet[name]': {
				required: window.translations.required,
			},
			'cabinet[surname]': {
				required: window.translations.required,
			},
			'cabinet[email]': {
				required: window.translations.required,
				email: window.translations.emailInvalid,
			},
			'cabinet[phone]': {
				required: window.translations.required,
			},
			'register[company]': {
				required: window.translations.required,
			},
			'register[legal_address]': {
				required: window.translations.required,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});

	// Cabinet reset
	$("form[name='cabinet_reset']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'cabinet_reset[current_password]': {
				required: true,
			},
			'cabinet_reset[password]': {
				required: true,
			},
			'cabinet_reset[confirm_password]': {
				required: true,
				equalTo: '#password',
			},
		},
		messages: {
			'cabinet_reset[current_password]': {
				required: window.translations.required,
			},
			'cabinet_reset[password]': {
				required: window.translations.required,
			},
			'cabinet_reset[confirm_password]': {
				required: window.translations.required,
				equalTo: window.translations.equalTo,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
})();
